import React from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AUTH_SEND_MAIN_LINK, AUTH_PROFILE_INVITE } from 'apps/auth/constants/UrlConstants';

const Text = styled.div`
    p {
        margin-top: 0;
    }
`;

const PromoInviteCodeIntro = (props) => {
    const getText = (text) => {
        return (
            <Text>
                <DangerouslyHtml dangerouslyHtml={text} />
            </Text>
        );
    };

    return (
        <BaseLayout showChat={props?.stateOptions?.showChat}>
            <InfoPage
                topButtonType={'link'}
                topButtonCaption={props.notNowButton}
                topButtonLink={AUTH_SEND_MAIN_LINK}
                iconName={'wink-80'}
                iconColor={'primary'}
                headerText={getText(props.profilePromoInviteCodeTitle)}
                secondaryText={getText(props.profilePromoInviteCodeInfo)}
                primaryButtonCaption={props.profilePromoInviteCodeButton}
                primaryButtonType={'link'}
                primaryButtonLink={AUTH_PROFILE_INVITE}
            />
        </BaseLayout>
    );
};

const mapStateToProps = (state) => {
    return {
        profilePromoInviteCodeTitle: state.messages.pageMessages.profilePromoInviteCodeTitle,
        profilePromoInviteCodeInfo: state.messages.pageMessages.profilePromoInviteCodeInfo,
        profilePromoInviteCodeButton: state.messages.pageMessages.profilePromoInviteCodeButton,
        notNowButton: state.messages.pageMessages.notNowButton,
    };
};

export default connect(mapStateToProps)(BasePage(PromoInviteCodeIntro));
